import React from 'react';
import Countdown from "../../ui/Countdown";
import CTALink from "../../ui/CTA/CTALink";
import HeadingXSmall from "../../ui/Typography/titles/HeadingXSmall";
import styles from './DealCommunication.module.scss';
const DealCommunication = ({ dealMessage, textColor, expiresAt = null, countdownText, link, }) => {
    const content = (React.createElement(HeadingXSmall, { Tag: "div", center: true },
        dealMessage,
        React.createElement(Countdown, { expiresAt: Number(expiresAt), countdownTranslatedText: countdownText, showDays: true, showHours: true, showMinutes: true, showSeconds: true })));
    const withLink = (React.createElement(CTALink, { href: link, className: styles.dealCommunication, style: { color: textColor } }, content));
    const noLink = (React.createElement("div", { className: styles.dealCommunication, style: { color: textColor } }, content));
    return React.createElement(React.Fragment, null, link ? withLink : noLink);
};
export default DealCommunication;
//# sourceMappingURL=DealCommunication.js.map